import clienteAxios from "../config/axios";

export async function getAllNivel5s() {
    return clienteAxios.get(`/nivel5`);
}

export async function addNivel5(datos) {
    
    const codNivel5 = datos.codNivel5
    const name = datos.name
    const descrp = datos.descrp
    const nivel5Nivel4ID = datos.nivel5Nivel4._id
    const codNivel4 = datos.nivel5Nivel4.codNivel4
    const direccion = datos.direccion || null
    const lat = datos.lat || null
    const lng = datos.lng || null

    return clienteAxios.post(`/nivel5`,{codNivel5, name, descrp, nivel5Nivel4ID, codNivel4, direccion, lat, lng});
}

export async function updateNivel5(dato) {
    
    const id = dato.id
    const updates = {
        id: dato.id,
        codNivel5:dato.codNivel5,
        name: dato.name,
        descrp: dato.descrp,
        direccion: dato.direccion || null,
        lat: dato.lat || null,
        lng: dato.lng || null
    }

    return clienteAxios.put(`/nivel5/${id}`,updates);
}

export async function deleteNivel5(id) { return clienteAxios.delete(`/nivel5/${id}`,id); }

export async function deleteNivel5AndChildren(id, deleteActivesToo) {
    return clienteAxios.delete(`/nivel5/deleteLevelAndChildren/${id}?deleteActivesToo=${deleteActivesToo}`,{id});
}


export async function updatePositioning(updates){
    return clienteAxios.post(`/nivel5/updatePositioning`,{updates});
}
